import React from "react";

export default function Upgrade() {
	return <div className="content-wrapper">Coming Soon!</div>;
}
